import { render, staticRenderFns } from "./BasePagination.vue?vue&type=template&id=4d35a59f&scoped=true"
import script from "./BasePagination.vue?vue&type=script&lang=js"
export * from "./BasePagination.vue?vue&type=script&lang=js"
import style0 from "./BasePagination.vue?vue&type=style&index=0&id=4d35a59f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d35a59f",
  null
  
)

export default component.exports